import { Component } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';

@Component({
  selector: 'spin-box-accessibility',
  templateUrl: './spin-box-accessibility.component.html',
  styleUrls: ['./spin-box-accessibility.component.sass']
})
export class SpinBoxAccessibilityComponent {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;

  constructor(private templateService: TemplateUpdateService) { }
}
